/***
 * 全局注册svg-icon组件,用于展示svg图标
 */
import Vue from 'vue';
import SvgIcon from '../components/common/Icon.vue';

Vue.component('svg-icon', SvgIcon);

// icons图标自动加载，就不需要在svg有更新时，手动的增加引入或者删除引入，注意必须是src/assets/icons下进行图标的修改
const req = require.context('../assets/icons', true, /\.svg$/);
req.keys().forEach(req);
/*
require.context使用教程 https://webpack.docschina.org/guides/dependency-management/
*/
